import PropTypes from 'prop-types'

import useMatchMedia from 'assets/lib/hooks/use_match_media'
import Container from './container'

const Navigation = ({ children, ...props }) => {
  const isMobile = useMatchMedia('mobile')

  return isMobile ? <Container {...props}>{children}</Container> : null
}

Navigation.propTypes = {
  children: PropTypes.string.isRequired,
  hasNotifications: PropTypes.bool.isRequired,
  searchSheet: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      excludeFilters: PropTypes.array,
      therapistsPath: PropTypes.string
    })
  ])
}

export default Navigation
